import { useEffect } from 'react';
import styles from '../../index.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import PendingApprovalList from './PendingApprovalList';
import { RootState } from 'src/store';
import Pagination from '@navi/web-ui/lib/components/Pagination/Pagination';
import { createQueryParams, readQueryParams } from 'src/utils/QueryParamsHelper';
import { useNavigate } from 'react-router-dom';
import { EntityType, PENDING_APPROVALS_KEY, initialPaginationParams } from '../../constant';
import { getPendingApprovals } from '../../actions/ApprovalsActions';
import { setSelectedIdApprovalItem } from '../../reducers/ApprovalsSlice';

const IDCardApprovals = () => {
  const totalIdCardPendingApprovals = useSelector(
    (state: RootState) => state.approvals.totalIdCardPendingApprovals
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { [PENDING_APPROVALS_KEY]: queryParams } = readQueryParams();

  const fetchIdCardApprovals = () => {
    dispatch(
      getPendingApprovals({
        ...initialPaginationParams,
        ...queryParams,
        entityType: EntityType.AGENT_ID
      })
    );
  };

  useEffect(() => {
    fetchIdCardApprovals();
    return () => {
      dispatch(setSelectedIdApprovalItem(null));
    };
  }, []);

  const handlePageChange = (page: number) => {
    const params = { ...initialPaginationParams, ...queryParams, page: page.toString() };
    const url = createQueryParams({ [PENDING_APPROVALS_KEY]: params });
    navigate(url, {
      replace: true
    });
    dispatch(getPendingApprovals({ ...params, entityType: EntityType.AGENT_ID }));
    dispatch(setSelectedIdApprovalItem(null));
  };

  return (
    <div className={styles.container}>
      <div className={styles.pendingList}>
        <PendingApprovalList />
        {totalIdCardPendingApprovals ? (
          <Pagination
            totalCount={totalIdCardPendingApprovals}
            hidePageSizeOptions
            onPageChange={handlePageChange}
            currentPage={queryParams?.page ? parseInt(queryParams.page) : 1}
            siblingCount={0}
            hidePageDetails
          />
        ) : null}
      </div>
    </div>
  );
};

export default IDCardApprovals;
